module.exports = __webpack_public_path__ + "img/user.5a6c922f.png";